import type { AxiosRequestConfig } from 'axios';
import { AxiosError } from 'axios';

type RequestConfig = Omit<AxiosRequestConfig, 'url' | 'method' | 'data' | 'params'>;

export default async function useRequest<T, TError = unknown>(
	url: string,
	method: string,
	payload = {},
	params = {},
	config: RequestConfig = {},
) {
	const data = ref<T>();
	const errorMessage = ref<string>('');
	const errorMetadata = ref<TError | null>();

	try {
		errorMessage.value = '';
		errorMetadata.value = null;
		const res = await apiClient.request({
			url,
			method,
			params,
			data: payload,
			headers: {
				'X-Peatix-App-Token': import.meta.env.VITE_PEATIX_TOKEN, // For identifying the Peasy request
			},
			...config,
		});

		data.value = res.data;
	} catch (err) {
		if (err instanceof AxiosError) {
			errorMessage.value = err?.response?.data?.error_description?.message || err?.response?.data?.error_description || 'Something went wrong';
			errorMetadata.value = err?.response?.data?.error_description?.metadata || err?.response?.data?.metadata;
		}
	}

	return {
		data,
		errorMessage,
		errorMetadata,
	};
}
